<script lang="js" setup>
import { useStorage } from '@vueuse/core'

const emits = defineEmits(['change'])
const eye = useStorage('ttx-eye', false)

function change(value) {
  eye.value = value
  emits('change', value)
}
</script>

<template>
  <div class="flex items-center gap-2 text-textPrimary select-none">
    <slot />
    <SvgoCommonEye v-if="eye" class="w-4 h-4 cursor-pointer" @click="change(false)" />
    <SvgoCommonEyeClose v-else class="w-4 h-4 cursor-pointer" @click="change(true)" />
  </div>
</template>
